import { render, staticRenderFns } from "./mixed1.vue?vue&type=template&id=3036578c&scoped=true&"
import script from "./mixed1.vue?vue&type=script&lang=js&"
export * from "./mixed1.vue?vue&type=script&lang=js&"
import style0 from "./mixed1.vue?vue&type=style&index=0&id=3036578c&scoped=true&lang=css&"
import style1 from "./mixed1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036578c",
  null
  
)

export default component.exports